import tableLayouts from 'core/service/pdf-generation/products/common/layout'
import { deduplicatePdfImages } from 'core/service/pdf-generation/utils/image-deduplication'
import { splitWordsInDocDefinition } from 'core/service/pdf-generation/utils/line-wrapper'

// FIXME: write snapshot to test this
const initPdfMake = async () => {
  const pdfMake = await import('pdfmake/build/pdfmake.js')
  const vfsfonts = await import('./vfs-fonts.js')

  global.pdfMake.vfs = vfsfonts.default
  global.pdfMake.fonts = {
    Helvethaica: {
      normal: 'dbhelvethaica55-webfont.woff',
      bold: 'dbhelvethaica75-webfont.woff',
    },
    HelvethaicaLight: {
      normal: 'dbhelvethaica35-webfont.woff',
    },
    PSLTextPro: {
      normal: 'PSL001p0.ttf',
      bold: 'PSL002p0.ttf',
      italics: 'PSL003p0.ttf',
    },
  }
  global.pdfMake.tableLayouts = tableLayouts
  return pdfMake
}

export const createPdfDocument = (createDocDefinition) => async (props) => {
  const pdfMake = await initPdfMake()
  const docDefinition = await createDocDefinition(props)
    .then(splitWordsInDocDefinition)
    .then(deduplicatePdfImages)

  return pdfMake.createPdf(docDefinition, pdfMake.tableLayouts, pdfMake.fonts, pdfMake.vfs)
}
